const Stats = () => {
  return (
    <div className="flex my-4 font-montserrat gap-12 justify-evenly py-20 mx-44 flex-wrap">
      <div className="flex flex-col">
        <p className="text-6xl	">15K</p>
        <p className="text-[#737373]">Happy Customers</p>
      </div>
      <div className="flex flex-col">
        <p className="text-6xl	">150K</p>
        <p className="text-[#737373]">Monthly Visitors</p>
      </div>
      <div className="flex flex-col">
        <p className="text-6xl	">15</p>
        <p className="text-[#737373]">Countries Worldwide</p>
      </div>
      <div className="flex flex-col">
        <p className="text-6xl	">100+</p>
        <p className="text-[#737373]">Top Partners</p>
      </div>
    </div>
  );
};

export default Stats;
